var _circle, _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTelegram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 84,
    viewBox: "0 0 84 84",
    fill: "currentColor",
    stroke: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 42,
    cy: 42,
    r: 30
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_17582_252717)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 42.0033,
    cy: 42.0004,
    r: 25.7143,
    fill: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_17582_252717)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.951 48.0825V52.2236C36.9517 52.3643 36.9966 52.5012 37.0795 52.615C37.1623 52.7288 37.2789 52.8136 37.4126 52.8575C37.5463 52.9013 37.6905 52.902 37.8246 52.8594C37.9587 52.8167 38.076 52.733 38.1599 52.62L40.5822 49.3236L36.951 48.0825ZM50.2858 32.4816C50.1852 32.4099 50.0667 32.3675 49.9435 32.359C49.8203 32.3505 49.6971 32.3762 49.5876 32.4334L29.4983 42.9245C29.3827 42.9855 29.2875 43.079 29.2243 43.1935C29.1611 43.3079 29.1327 43.4383 29.1425 43.5687C29.1524 43.6991 29.2001 43.8237 29.2798 43.9274C29.3595 44.031 29.4677 44.1091 29.5912 44.1521L35.176 46.0611L47.0697 35.8914L37.8662 46.9798L47.226 50.1789C47.3189 50.2101 47.4174 50.2206 47.5148 50.2098C47.6122 50.1989 47.706 50.1668 47.7897 50.1159C47.8734 50.0649 47.9449 49.9963 47.9993 49.9148C48.0537 49.8333 48.0896 49.7409 48.1046 49.6441L50.5599 33.1262C50.5781 33.004 50.5621 32.879 50.5137 32.7653C50.4654 32.6515 50.3865 32.5533 50.2858 32.4816Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_17582_252717",
    x: 0.289062,
    y: 0.286133,
    width: 83.4297,
    height: 83.4287,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.305882 0 0 0 0 0.733333 0 0 0 0 0.721569 0 0 0 0.18 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_17582_252717"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_17582_252717",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_17582_252717"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21.4286,
    height: 21.4286,
    fill: "white",
    transform: "translate(29.1406 32.3574)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.16244cb8f8c7c60857cdb7dba167d143.svg";
export { ForwardRef as ReactComponent };